import React from 'react'
import {cn} from '@/lib/utils'
import {useProductContext} from '@/context/ProductContext'
import {VariationAttributeType, VariantType} from '@/types/product'

interface ProductVariantButtonProps {
    name: string
    value: string
    handleVariantSelect: (value: string) => void
    isSelected: boolean
}

export const ProductVariantButton: React.FC<ProductVariantButtonProps> = ({
    name,
    value,
    handleVariantSelect,
    isSelected
}) => {
    return (
        <button
            onClick={() => handleVariantSelect(value)}
            className={cn('rounded-md border-2 border-solid p-2 theme-medium border-background', {
                'border-accent': isSelected
            })}
        >
            {name}
        </button>
    )
}

interface ProductVariantPickerProps {
    variationAttribute: VariationAttributeType
    variants: VariantType[]
    selectedValue?: string
}

export const ProductVariantPicker: React.FC<ProductVariantPickerProps> = ({
    variationAttribute,
    variants,
    selectedValue
}) => {
    const {name, id, values} = variationAttribute
    const {setVariantProductId} = useProductContext()

    const handleVariantSelect = (value: string) => {
        const variant = variants.find((v) => v.variationValues[id] === value)
        if (variant?.productId) {
            setVariantProductId(variant.productId)
        } else {
            console.warn('[VariantPicker] No variant found for value:', value, 'with id:', id)
        }
    }

    return (
        <div>
            <div className="mb-[.5rem]">Select {name}:</div>
            <div className="flex flex-wrap gap-2">
                {values.map(({name, value}, index) => {
                    return (
                        <ProductVariantButton
                            key={`product-variant-${value}-${index}`}
                            name={name}
                            value={value}
                            isSelected={selectedValue === value}
                            handleVariantSelect={handleVariantSelect}
                            data-testid="productVariantPicker-ProductVariantButton"
                        />
                    )
                })}
            </div>
        </div>
    )
}
